import { translate } from '@manomano-internal/i18n/esm/placeholders';
export const {
  outlineBundleHeaderTitle,
  outlineBundleHeaderTitleMF,
  outlineBundleHeaderTitleFreeDelivery,
  outlineBundleHeaderTitleSameSeller
} = translate({
  "outlineBundleHeaderTitle": "Unbeatable offer",
  "outlineBundleHeaderTitleMF": "Your Essential Pack delivered for free within 48h",
  "outlineBundleHeaderTitleFreeDelivery": "Your Essential Pack with free delivery",
  "outlineBundleHeaderTitleSameSeller": "Your bundled shipment to save on shipping costs"
});